/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
export const HTTP_BAD_REQUEST_STATUS = 400;
export const HTTP_UNAUTHORISED_STATUS = 401;
export const HTTP_CONFLICT_STATUS = 409;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

export const ASGARDEO_SDK_TOKEN_GRANT_ERROR = 'invalid_grant';
export const ASGARDEO_SDK_TOKEN_GRANT_ERROR_DESCRIPTION =
  'Invalid refresh token state';
export const ASGARDEO_SDK_REFRESH_TOKEN_ERROR_CODE = 'SPA-AUTH_HELPER-HR-SE01';
export const TOKEN_REFRESH_ERROR_EVENT = 'tokenRefreshError';
export const APIANALYTICS = 'apianalytics';
export const ASGARDEO_STATE_SUFFIX_PATTERN = /_request_\d$/; // Used to identify the request counter in the state
export const ASGARDEO_STATE_SUFFIX_CHOREO = '_request_0'; // Used to identify the request counter in the state

// IDPs of Asgardeo
export const IDP_GOOGLE = 'Google';
export const IDP_GITHUB = 'GitHub';
export const IDP_MICROSOFT = 'Microsoft';
export const IDP_ANONYMOUS = 'Choreo Anonymous IdP';
export const IDP_ENTERPRISE = 'EnterpriseIDP';
export const IDP_E2E = 'Choreo Internal IdP';

export const NOT_DEPLOYED = 'NOT_DEPLOYED';
export const SampleOASURL =
  'https://raw.githubusercontent.com/wso2/choreo-samples/main/proxy/openapi.yaml';
export const SampleOASURLEndpoint = 'https://petstore3.swagger.io/api/v3';
export const defaultTimeout: string = '60000';
export const EMPTY_BRANCH = '';
export const SAMPLE_REPO_ORG = 'wso2';
export const SAMPLE_REPO_NAME = 'choreo-samples';
export const VECTOR_DATABASE = 'vector-db';
export const DATABASE = 'db';
export const GEN_AI_SERVICES = 'GenAI';
export const REDESIGN_API_SETTINGS_UX = 'Redesigning API Settings UX';
export const CHOREO_CLOUD = 'choreo';
